var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{class:_vm.$style.root},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_c('WebShare',{staticClass:"web-share",attrs:{"title":_vm.title,"text":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }